module.exports = __webpack_public_path__ + "static/media/all_vendors.ba950f1b.svg";